module.exports = __webpack_public_path__ + "static/img/game-rating-administration-committee.af9977f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/visual-marketing-detail/game-rating-administration-committee.jpg
// module id = rCNO
// module chunks = 0